import React from "react";
import styles from "./FolderProgress.module.sass";

//screens
import Overview from "./Overview";
import PopularProducts from "./Folderfiles";

const FolderProgress = ({ folder, onFolderUpdate }) => {
    return (
        <>
            <div className={styles.section}>
                <div className={styles.row}>
                    <div className={styles.col}>
                        <Overview className={styles.card} folder={folder} onFolderUpdate={onFolderUpdate} />
                    </div>
                    <div className={styles.col}>
                        <PopularProducts className={styles.card} folder={folder} folderId={folder?.id} views="4" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default FolderProgress;
